import __decorate from "../_virtual/_@oxc-project_runtime@0.147.0/helpers/esm/decorate.js";
import { LitElement, css, html } from "lit";
import { property, state } from "lit/decorators.js";
import "@progressive-development/pd-dialog/pd-popup";
//#region src/pd-resize-content/PdResizeContent.ts
/**
* @license
* Copyright (c) 2021 PD Progressive Development UG. All rights reserved.
*/
/**
* Responsive content component that switches between inline and popup display.
*
* @tagname pd-resize-content
* @summary Responsive content wrapper that shows popup below breakpoint.
*
* @slot resize-content - Main content shown when viewport is wide enough.
* @slot preview-content - Preview content shown in popup trigger when viewport is narrow.
*/
var PdResizeContent = class extends LitElement {
	constructor(..._args) {
		super(..._args);
		this.resizeWidth = "1232px";
		this._hideContent = false;
	}
	static {
		this.styles = css`
    :host {
      display: block;
    }

    h3 {
      color: var(--pd-default-col);
      font-family: var(--pd-default-font-title-family);
    }

    p {
      color: var(--pd-default-col);
    }
  `;
	}
	connectedCallback() {
		super.connectedCallback();
		this._mediaQueryList = window.matchMedia(`(min-width: ${this.resizeWidth})`);
		this._mediaQueryHandler = (e) => {
			this._hideContent = !e.matches;
		};
		this._hideContent = !this._mediaQueryList.matches;
		this._mediaQueryList.addEventListener("change", this._mediaQueryHandler);
	}
	disconnectedCallback() {
		super.disconnectedCallback();
		if (this._mediaQueryList && this._mediaQueryHandler) this._mediaQueryList.removeEventListener("change", this._mediaQueryHandler);
	}
	render() {
		return this._hideContent ? html`
          <pd-popup>
            <div slot="small-view"><slot name="preview-content"></slot></div>
            <div slot="content"><slot name="resize-content"></slot></div>
          </pd-popup>
        ` : html`<slot name="resize-content"></slot>`;
	}
};
__decorate([property({ type: String })], PdResizeContent.prototype, "resizeWidth", void 0);
__decorate([state()], PdResizeContent.prototype, "_hideContent", void 0);
//#endregion
export { PdResizeContent };
